import React from 'react';
import Icon from '../../../components/AppIcon';

const VisitorFlowHeatmap = ({ data }) => {
  const getIntensityColor = (intensity) => {
    if (intensity >= 80) return 'bg-error';
    if (intensity >= 60) return 'bg-warning';
    if (intensity >= 40) return 'bg-accent';
    if (intensity >= 20) return 'bg-secondary';
    return 'bg-primary/30';
  };

  const getIntensityLabel = (intensity) => {
    if (intensity >= 80) return 'Critical';
    if (intensity >= 60) return 'High';
    if (intensity >= 40) return 'Moderate';
    if (intensity >= 20) return 'Low';
    return 'Minimal';
  };

  return (
    <div className="bg-card rounded-lg p-6 shadow-conservation border border-border">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-xl font-semibold text-foreground mb-1">Visitor Flow Heat Map</h3>
          <p className="text-sm text-muted-foreground">Popular trails and congestion analysis</p>
        </div>
        <Icon name="Map" size={24} className="text-primary" />
      </div>
      <div className="space-y-4">
        {data?.map((trail) => (
          <div key={trail?.id} className="space-y-2">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <Icon name="MapPin" size={18} className="text-muted-foreground" />
                <span className="text-sm font-medium text-foreground">{trail?.name}</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-xs text-muted-foreground">{trail?.visitors} visitors</span>
                <span className={`text-xs font-medium px-2 py-1 rounded ${
                  trail?.intensity >= 80 ? 'bg-error/20 text-error' :
                  trail?.intensity >= 60 ? 'bg-warning/20 text-warning' :
                  trail?.intensity >= 40 ? 'bg-accent/20 text-accent': 'bg-secondary/20 text-secondary'
                }`}>
                  {getIntensityLabel(trail?.intensity)}
                </span>
              </div>
            </div>
            
            <div className="relative h-2 bg-muted rounded-full overflow-hidden">
              <div
                className={`absolute left-0 top-0 h-full ${getIntensityColor(trail?.intensity)} transition-all duration-500`}
                style={{ width: `${trail?.intensity}%` }}
              />
            </div>

            <div className="flex items-center gap-4 text-xs text-muted-foreground pl-7">
              <span className="flex items-center gap-1">
                <Icon name="Clock" size={12} />
                Avg: {trail?.avgDuration}
              </span>
              <span className="flex items-center gap-1">
                <Icon name="Users" size={12} />
                Peak: {trail?.peakTime}
              </span>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 pt-4 border-t border-border">
        <div className="flex items-center justify-between text-xs">
          <span className="text-muted-foreground">Congestion Level:</span>
          <div className="flex items-center gap-2">
            <div className="flex items-center gap-1">
              <div className="w-3 h-3 rounded-full bg-primary/30" />
              <span className="text-muted-foreground">Minimal</span>
            </div>
            <div className="flex items-center gap-1">
              <div className="w-3 h-3 rounded-full bg-secondary" />
              <span className="text-muted-foreground">Low</span>
            </div>
            <div className="flex items-center gap-1">
              <div className="w-3 h-3 rounded-full bg-accent" />
              <span className="text-muted-foreground">Moderate</span>
            </div>
            <div className="flex items-center gap-1">
              <div className="w-3 h-3 rounded-full bg-warning" />
              <span className="text-muted-foreground">High</span>
            </div>
            <div className="flex items-center gap-1">
              <div className="w-3 h-3 rounded-full bg-error" />
              <span className="text-muted-foreground">Critical</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisitorFlowHeatmap;